import Color from 'color';
import { cashColor, redColor } from 'pages/Logs/components/LogTable.styled';
import styled from 'styled-components';

const graphRes1 = '500px';
const tipBorder = Color('lightgrey').darken(0.08).toString();
const tipMuted = '#6b7280';
const tipInk = '#1f2937';

export const Container = styled.div`
  background: #fff;
  border: 1px solid ${tipBorder};
  border-radius: 10px;
  padding: 10px 12px;
  color: ${tipInk};
  width: max-content;
  max-width: min(280px, 90vw);
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.06),
    0 8px 20px rgba(15, 23, 42, 0.1);
  display: flex;
  flex-direction: column;
  gap: 6px;
  @media(max-width: ${graphRes1}) {
    padding: 8px 10px;
    max-width: min(240px, 92vw);
  }
`;

export const TipTitle = styled.div`
  font-weight: 600;
  font-size: 12.5px;
  letter-spacing: 0.01em;
  color: ${tipInk};
  line-height: 1.25;
  padding-bottom: 6px;
  margin-bottom: 2px;
  border-bottom: 1px solid ${Color(tipBorder).lighten(0.05).toString()};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media(max-width: ${graphRes1}) {
    font-size: 12px;
  }
`;

export const TipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
`;

export const TipSwatch = styled.span<{ fill: string }>`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ fill }) => fill || tipMuted};
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
`;

export const TipLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${tipMuted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media(max-width: ${graphRes1}) {
    font-size: 11px;
  }
`;

export const TipValue = styled.span<{ tone?: 'plus' | 'minus' | 'neutral' }>`
  flex-shrink: 0;
  font-size: 12.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ tone }) => (
    tone === 'minus' ? redColor
      : tone === 'plus' ? cashColor
        : tipInk
  )};
  @media(max-width: ${graphRes1}) {
    font-size: 12px;
  }
`;

export const TipPct = styled.span`
  flex-shrink: 0;
  font-size: 10.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${tipMuted};
  background: ${Color('lightgrey').lighten(0.12).toString()};
  border-radius: 999px;
  padding: 2px 6px;
  line-height: 1.2;
`;

export const TipStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 2px;
`;

export const TipSubRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 2px;
`;

export const TipMore = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: ${tipMuted};
  padding-top: 2px;
`;

export const TipHeadRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 6px;
  margin-bottom: 2px;
  border-bottom: 1px solid ${Color(tipBorder).lighten(0.05).toString()};
`;

export const TipHeadName = styled.div`
  font-weight: 600;
  font-size: 12.5px;
  color: ${tipInk};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media(max-width: ${graphRes1}) {
    font-size: 12px;
  }
`;

/* ---- legacy aliases (kept so older markup still compiles if referenced) ---- */
export const FlexCont = styled.div<{ fill?: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ fill }) => fill || 'inherit'};
`;

export const Value = styled.div<{ flowType: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ flowType }) => (flowType === '-' ? redColor
    : flowType === 'count' ? tipMuted : cashColor)};
`;

export const Name = styled.div`
  font-weight: 600;
  font-size: 12.5px;
  color: ${tipInk};
`;

export const Bold = styled.div`
  font-weight: 700;
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
`;

export const AreaChartItems = styled(TipStack)``;

export const Value2 = styled(TipStack)<{ flowType?: string }>``;

export const FlexCont2 = styled(TipSubRow)``;

export const Bold2 = styled(TipValue)``;

export const Name4 = styled(TipTitle)``;

export const Value3 = styled(TipRow)<{ fill?: string; flowType?: string }>``;

export const Value4 = styled(TipRow)<{ flowType?: string }>``;

export const Circle = styled(TipSwatch)``;

export const Name3 = styled(TipLabel)<{ fill?: string }>`
  color: ${({ fill }) => fill || tipMuted};
`;

export const Name5 = styled(TipLabel)<{ fill?: string }>`
  color: ${({ fill }) => fill || tipMuted};
`;

export const Name6 = styled(TipLabel)``;

export const Bold3 = styled(TipValue)``;
